import React, { ReactElement } from 'react';
import {
  withAppInsightsTracking,
  UButtonTypes,
  UButtonSizes
} from '@exxonmobil/uit-uda-ui-components-lib';
import { Button, Checkbox, Input } from 'antd';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';

import { WorkCenterBaseline } from 'models/baselines';
import { BaselineItem } from './BaselineItem';
import useBaselines from './Baselines.hooks';
import { showRequestedBaselines } from './Baselines.helpers';
import styles from './Baselines.module.scss';
import { ACTION } from './Baselines.types';

const BaselinesComponent = (): ReactElement => {
  const {
    searchBaselines,
    filteredBaselines,
    selectionChangeAll,
    numberOfBaselinesRequested,
    allSelected,
    isUserApprover,
    contextHolder,
    onSearchChangeHandler,
    onWorkCentersPendingClickHandler,
    onClearFiltersClickHandler,
    onIconClickHandler,
    onCheckboxClickHandler,
    onSelectAllClickHandler,
    onApprovalClickHandler,
    disableApproveRejectButton
  } = useBaselines();
  const { Search } = Input;

  return (
    <div className={styles.page}>
      {contextHolder}
      <div className={styles.mainHeaderContainer}>
        <div className={styles.headerContainer}>
          <div className={styles.subheaderContainer}>
            <h1 className={styles.title}>Baselines</h1>
            {isUserApprover && (
              <button
                className={styles.pendingButton}
                type="button"
                onClick={onWorkCentersPendingClickHandler}
              >
                <div>
                  ** {numberOfBaselinesRequested} Work Centers have pending
                  changes requiring approval
                </div>
              </button>
            )}
          </div>
          {isUserApprover && (
            <div className={styles.subheaderContainer}>
              <div>
                <Button
                  data-testid="rejectButton"
                  type={UButtonTypes.PRIMARY}
                  icon={<StopOutlined />}
                  size={UButtonSizes.LARGE}
                  disabled={disableApproveRejectButton()}
                  onClick={() => onApprovalClickHandler(ACTION.REJECT)}
                >
                  Reject Selected
                </Button>
              </div>
              <div>
                <Button
                  data-testid="approveButton"
                  type={UButtonTypes.PRIMARY}
                  icon={<CheckCircleOutlined />}
                  size={UButtonSizes.LARGE}
                  disabled={disableApproveRejectButton()}
                  onClick={() => onApprovalClickHandler(ACTION.APPROVE)}
                >
                  Approve Selected
                </Button>
              </div>
            </div>
          )}
        </div>
        <div className={styles.searchbarContainer}>
          <Search
            data-testid="searchField"
            key="baseline-search"
            placeholder="Search by work center or company"
            value={searchBaselines}
            onChange={(event) => {
              onSearchChangeHandler(event.target.value);
            }}
            enterButton
            style={{ width: 400 }}
          />
          <button
            className={styles.clearFiltersButton}
            type="button"
            onClick={onClearFiltersClickHandler}
          >
            <h2>Clear Filters</h2>
          </button>
        </div>
        <div className={styles.lowerHeaderContainer}>
          {isUserApprover && (
            <Checkbox checked={allSelected} onClick={onSelectAllClickHandler}>
              Select All
            </Checkbox>
          )}
        </div>
      </div>
      <div className={styles.baselineItemsContainer}>
        {filteredBaselines
          .filter((baseline) =>
            showRequestedBaselines(baseline, selectionChangeAll)
          )
          .map((baseline: WorkCenterBaseline) => {
            return (
              <BaselineItem
                key={baseline.workCenter}
                baseline={baseline}
                onIconClickHandler={onIconClickHandler}
                onCheckboxClickHandler={onCheckboxClickHandler}
                isUserApprover={isUserApprover}
              />
            );
          })}
      </div>
    </div>
  );
};

export const Baselines = withAppInsightsTracking(BaselinesComponent);
